<template>
  <draggable
    v-bind="dragOptions"
    tag="div"
    handle=".handle"
    class="item-container"
    :children_recursive="children_recursive"
    :value="value"
    @input="emitter"
  >
    <div class="item-group" v-for="(el, index) in realValue" :key="index">
      <JsonSchemaTreeItem :item="el" @input="onItemUpdated" @delete="onDelete(index)">
        <b-button variant="ghost" class="handle mr-3 p-1" size="sm">
          <i class="fa fa-bars" />
        </b-button>
      </JsonSchemaTreeItem>
      <JsonSchemaTreeNode class="item-sub" v-model="el.children_recursive" />
    </div>
  </draggable>
</template>

<script>
import draggable from 'vuedraggable';
import JsonSchemaTreeItem from './JsonSchemaTreeItem.vue';

export default {
  name: 'JsonSchemaTreeNode',
  components: {
    draggable,
    JsonSchemaTreeItem
  },
  computed: {
    dragOptions() {
      return {
        animation: 0,
        group: 'description',
        disabled: false,
        ghostClass: 'ghost',
      };
    },
    realValue() {
      return this.value ? this.value : this.children_recursive;
    }
  },
  props: {
    value: {
      required: false,
      type: Array,
      default: null
    },
    children_recursive: {
      required: false,
      type: Array,
      default: null
    }
  },
  methods: {
    emitter(value) {
      this.$emit('input', value);
    },
    onDelete(itemIndex) {
      // idk why it works but it does
      this.realValue.splice(itemIndex, 1);
    },
    onItemUpdated(item) {
      this.$emit('input', this.realValue);
    }
  }
};
</script>

<style scoped>
.item-container {
  margin: 0 0 1rem;
}

.item-sub {
  margin: 0 0 0 3rem;
}
</style>
